module.exports = __webpack_public_path__ + "img/canales-punto-de-pago.ae634ced.svg";